import {call, put, takeEvery, takeLatest} from "redux-saga/effects";
import {IBaseRespone} from "../../../model/respone/IBaseRespone";
import {rootActions} from "../../actions/rootActions";
import {loaiThuTuyenSinhApi} from "./../../../api/category/loaiThuTuyenSinhApi";
import {
    eDmLoaiThuTuyenSinhActionIds,
    IDmLoaiThuTuyenSinhActionTypes,
} from "./../../action-types/category/IDmLoaiThuTuyenSinhActions";
import {IDmLoaiThuTuyenSinh} from "../../../model/respone/category/IDmLoaiThuTuyenSinh";
import {IHeNganhTheoDotTuyenSinh} from "../../reducer-model/category/IDmLoaiThuTuyenSinhReducer";

export function* loaiThuTuyenSinhSaga(): any {
    yield takeLatest(eDmLoaiThuTuyenSinhActionIds.LOAD_START, loadWorker);
    yield takeLatest(
        eDmLoaiThuTuyenSinhActionIds.LOAD_THEO_DOT_START,
        loadByDotWorker
    );
    yield takeEvery(eDmLoaiThuTuyenSinhActionIds.SAVE_START, saveWorker);
    yield takeLatest(
        eDmLoaiThuTuyenSinhActionIds.LOAD_HE_NGANH_CHUYEN_NGANH_THEO_DOT_START,
        loadHeNganhsWorker
    );
    yield takeEvery(
        eDmLoaiThuTuyenSinhActionIds.DELETE_MANY_START,
        deleteManyWorker
    );
    yield takeEvery(
        eDmLoaiThuTuyenSinhActionIds.SAVE_MULTIPLE_START,
        insertMultipleWorker
    );
}

function* loadWorker(action: IDmLoaiThuTuyenSinhActionTypes): any {
    const res: IBaseRespone = yield call(loaiThuTuyenSinhApi.SelectViewModelAll);
    if (res.is_success) {
        yield put(rootActions.category.loaiThuTuyenSinh.LOAD_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.category.loaiThuTuyenSinh.LOAD_ERRR(res.message ?? "Có lỗi")
        );
    }
}

function* saveWorker(action: IDmLoaiThuTuyenSinhActionTypes): any {
    let res: IBaseRespone;
    const payload = action.payload as IDmLoaiThuTuyenSinh;
    if (payload.id_thu_chi_main > 0) {
        res = yield call(loaiThuTuyenSinhApi.Update, payload);
    } else {
        res = yield call(loaiThuTuyenSinhApi.Insert, payload);
    }
    if (res) {
        if (res.is_success) {
            yield put(rootActions.category.loaiThuTuyenSinh.SAVE_SUCCESS(res.data));
        } else {
            yield put(
                rootActions.category.loaiThuTuyenSinh.SAVE_ERROR(
                    res.message ?? "Có lỗi"
                )
            );
        }
    }
}

function* deleteWorker(action: IDmLoaiThuTuyenSinhActionTypes): any {
    const res: IBaseRespone = yield call(
        loaiThuTuyenSinhApi.Delete,
        action.payload as number
    );
    if (res.is_success) {
        yield put(rootActions.category.loaiThuTuyenSinh.DELETE_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.category.loaiThuTuyenSinh.DELETE_ERROR(
                res.message ?? "Có lỗi"
            )
        );
    }
}

function* deleteManyWorker(action: IDmLoaiThuTuyenSinhActionTypes): any {
    const res: number = yield call(
        loaiThuTuyenSinhApi.DeleteMany,
        action.payload as number[]
    );
    if (res > 0) {
        yield put(
            rootActions.category.loaiThuTuyenSinh.DELETE_MANY_SUCCESS(undefined)
        );
    } else {
        yield put(
            rootActions.category.loaiThuTuyenSinh.DELETE_MANY_ERROR("Có lỗi")
        );
    }
}

function* loadHeNganhsWorker(action: IDmLoaiThuTuyenSinhActionTypes): any {
    const res: IBaseRespone = yield call(
        loaiThuTuyenSinhApi.SelectHeNganhsByDot,
        action.payload as number
    );
    if (res.is_success) {
        yield put(
            rootActions.category.loaiThuTuyenSinh.LOAD_HE_NGANH_CHUYEN_NGANH_THEO_DOT_SUCCESS(
                res.data as IHeNganhTheoDotTuyenSinh[]
            )
        );
    } else {
        yield put(
            rootActions.category.loaiThuTuyenSinh.LOAD_HE_NGANH_CHUYEN_NGANH_THEO_DOT_ERRR(
                "Có lỗi"
            )
        );
    }
}

function* insertMultipleWorker(action: IDmLoaiThuTuyenSinhActionTypes): any {
    const res: IBaseRespone = yield call(
        loaiThuTuyenSinhApi.InsertMultiple,
        action.payload as IDmLoaiThuTuyenSinh[]
    );
    if (res.is_success) {
        yield put(
            rootActions.category.loaiThuTuyenSinh.SAVE_MULTIPLE_SUCCESS(res.data)
        );
    } else {
        yield put(
            rootActions.category.loaiThuTuyenSinh.SAVE_MULTIPLE_ERROR(
                res.message ?? "Có lỗi"
            )
        );
    }
}

function* loadByDotWorker(action: IDmLoaiThuTuyenSinhActionTypes): any {
    const res: IBaseRespone = yield call(
        loaiThuTuyenSinhApi.SelectByDot,
        action.payload as number
    );
    if (res.is_success) {
        yield put(
            rootActions.category.loaiThuTuyenSinh.LOAD_THEO_DOT_SUCCESS(res.data)
        );
    } else {
        yield put(
            rootActions.category.loaiThuTuyenSinh.LOAD_THEO_DOT_ERRR(
                res.message ?? "Có lỗi"
            )
        );
    }
}
